<template>
    <div class="courceList">
        <div class="search_container searchArea">
            <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">
                <el-form-item label="答题卡名称">
                    <el-input v-model="searchForm.keyWord" placeholder="请输入答题卡名称"> </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size ="mini" icon="search" @click='loadScantronList()'>查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table_container">
            <div align='left'>
                <el-button type="primary" @click="batchDown">批量下载</el-button>
                <el-button type="primary" @click="batchExam">创建考试</el-button>
            </div>
            <el-table v-loading="loading" :data="tableData" style="width: 100%" align='center'  @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column type="index" label="序号"  width="150" align='center' ></el-table-column>
                <el-table-column prop="id" label="key"  width="150" align='center' ></el-table-column>
                <el-table-column prop="name" label="答题卡名称"   align='center' ></el-table-column>
                <el-table-column prop="createTime" label="创建时间"  width="150" align='center' ></el-table-column>
                <el-table-column prop="operation" align='center' label="操作" width="300">
                    <template slot-scope='scope'>
                        <el-button icon='edit' size="mini" @click='showScantron(scope.row)'>预览</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
        </div>


        <!-- 批量创建考试 -->
        <el-dialog title="批量创建考试" width="85%"  :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancel">
             <!-- 批量填写控制区 -->
            <div class="batch-control"  align='center'>
                考试类型： 
                <el-select v-model="categoryBatch" filterable placeholder="可批量选择考试类型" style="width: 200px"    @change="handleChange">
                    <el-option v-for="item in examType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
            </div>


            <el-table v-loading="loading" :data="examList" style="width: 100%; margin-top: 20px" align='center' border  @selection-change="handleSelectionChange">
                <el-table-column type="index" label="序号"  width="150" align='center' ></el-table-column>
                <el-table-column prop="name" label="考试名称"   align='center' >
                    <!-- <template slot-scope='scope'>
                        <el-input v-model="scope.row.name" placeholder=""> </el-input>
                    </template> -->
                    <template slot-scope="scope">
                        <el-input 
                            v-model="scope.row.name" 
                            placeholder="请输入考试名称"
                            :class="{ 'error-border': showValidation && !scope.row.name }"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="category" label="考试类型"   align='center'  width="150">
                    <template slot-scope='scope'>
                        <!-- <span> {{ scope.row.category }}</span> -->
                        <el-select v-model="scope.row.category" filterable placeholder="请选择" style="width: 100%" :class="{ 'error-border': showValidation && isEmpty(scope.row.category) }">
                            <el-option v-for="item in examType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="courseId" label="所属课程"   align='center'  width="200">
                    <template slot-scope='scope'>
                        <el-select v-model="scope.row.courseId" filterable placeholder="请输入课程名称或编号" remote :remote-method="remoteCourse" style="width: 100%"  :class="{ 'error-border': showValidation && !scope.row.courseId }">
                            <el-option v-for="item in courceList" :key="item.id" :label="item.name+'('+item.course_no+')'" :value="item.id"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="semester" label="学年学期"   align='center' >
                    <template slot-scope='scope'>
                        <el-select v-model="scope.row.semester" filterable placeholder="请选择" :class="{ 'error-border': showValidation && !scope.row.semester }">
                            <el-option v-for="item in acadyearTermList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="joinCount" label="考试人数"   align='center' >
                    <template slot-scope='scope'>
                        <!-- <el-input v-model="scope.row.joinCount" placeholder=""> </el-input> -->
                        <el-input-number v-model="scope.row.joinCount" :min="1"  :class="{ 'error-border': showValidation && !scope.row.joinCount }"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column prop="examTime" label="考试时间"   align='center' >
                    <template slot-scope='scope'>
                        <el-date-picker v-model="scope.row.examTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" :class="{ 'error-border': showValidation && !scope.row.examTime }"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" :loading="submitCheck" @click="handleSubmit" >确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";
    import { template } from 'underscore';

    export default {
        name: 'courceList',
        data(){
            return {
                // 多选列表
                multipleSelection: [],
                tableData: [], 
                examList: [],
                tableHeight:0,
                loading:true, 
                isShow:false,
                schoolList: [],
                professionList: [],
                selCource: null, 
                selCourceDtl: null,
                searchForm:{ 
                    pageNo: 1, 
                    pageSize: 50, 
                    totalCount: 0, 
                    searchText: null, 
                    schoolId: null
                },
                dialogVisible:false,
                examType: [
                    {name: '期中', value: 0}, 
                    {name: '期末', value: 1}, 
                    {name: '补考', value: 2}, 
                    {name: '测验', value: 3}, 
                    {name: '其他', value: 4}, 
                    {name: '入学考', value: 5}, 
                    {name: '周考', value: 6}, 
                    {name: '月考', value: 7}, 
                    {name: '会考', value: 8}, 
                    {name: '自检', value: 9}, 
                ],
                courceList: [],
                acadyearTermList: [],
                // 当前学期
                nowSemester: mUtils.getSemesterWithHolidays(),
                // 显示必选校验
                showValidation: false,
                // 批量设置的考试类型
                categoryBatch: null,
                submitCheck: false
            }
        },
        components:{
            Pagination
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
      	mounted() {
            this.loadScantronList();
            this.loadCourceList()
            this.loadAcadyearTermList()
            // this.getSemesterWithHolidays()

	   },
    //    watch: {
    //         categoryBatch(newVal, oldVal) {
    //             console.log('message变化:', oldVal, '→', newVal);
    //         },

    //     },
        methods: {
            loadScantronList(){
                // _: Date.now()  // 使用当前时间戳
        
                this.loading = true;
                let userId = this.userInfo.id
                let param = { pageIndex: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, keyWord: this.searchForm.keyWord, userId: userId, _: Date.now()};
                return simpleApi.scantronGet(param).then((response) => {
                    const { status, data, message } = response;
                    if (status == 200) {
                        let result = data.data
                        this.loading = false;
                        this.tableData = result.list;
                        this.total = result.totalCount;
                        this.searchForm.totalCount =  result.totalCount;
                    }
                    }).catch((error) => {
                        this.loading = false;
                        console.log("error:", error);
                    });
            },

            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadScantronList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadScantronList()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 批量下载 在 for 循环中使用 async/await
            batchDown() {
                let length = this.multipleSelection.length
                if(length == 0) {
                    this.$message({ message: '请勾选答题卡',type: 'warning'});
                    return
                }
                this.multipleSelection.forEach(async (element,index) => {
                    try{
                        let param = {  controllerName: '/scantronjava/scantron/api/list', methodName: '/download'};
                        let id = element.id
                        let fileName = element.name  
                        await this.downloadSingleFile(param, id, fileName);
                        // await this.testDownload(param, id, fileName);

                    }catch(error){
                        console.error(`下载失败 ${item.name}:`, error);
                    }
                })
            },
            // 单个文件下载方法
            async downloadSingleFile(param, id, fileName) {
                return simpleApi.scantronDown(param,id).then((response) => {
                    
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName + '.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                
                }).catch((error) => {
                     console.log("error",error)
                     this.$message({ message: fileName +' 答题卡下载失败',type: 'error'});

                });


            },
            // 预览答题卡
            showScantron(row){
              
                let htmlUrl = row.htmlUrl
                // let htmlUrl = 'https://sh-vknow-admin.obs.cn-east-3.myhuaweicloud.com:443/html/2049df50-67ac-4cb4-8197-382ff160625b.html?v=' + Date.now();
                // 判断考试答题卡是否存在
                fetch(htmlUrl + '?v=' + Date.now())
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('网络响应不正常');
                        }
                        return response.text();
                    })
                    .then(htmlContent => {
                        // 在新窗口中显示 HTML
                        const newWindow = window.open('', '_blank');
                        newWindow.document.write(htmlContent);
                        newWindow.document.close();
                    })
                    .catch(error => {
                        console.error('打开失败:', error);
                        // 降级方案：直接打开（可能会下载）
                        window.open(htmlUrl, '_blank');
                    });
            },
            // 批量创建考试
            batchExam(){
     
                let length = this.multipleSelection.length
                if(length == 0) {
                    this.$message({ message: '请勾选答题卡后再创建考试',type: 'warning'});
                    return
                }
                let params = []
                this.multipleSelection.forEach(element =>{
                    // 默认初始化
                    let item = {
                        // 考试名称携带特殊字符直接替换
                        name: element.name.replace(/[@`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？\t\s]/g, ''),
                        semester: this.nowSemester,
                        examTime: new Date(),
                        joinCount: 1,
                        category: null,
                        courseId: null,
                        state: 0,
                        licenceId: this.userInfo.licenceId,
                        createrId: this.userInfo.id,
                        schoolId: this.userInfo.schoolId,
                        // 携带答题卡id
                        sheetId: element.id
                        
                    }
                    params.push(item)
                })
                this.examList = params
                this.dialogVisible = true

            },
            // 课程信息列表
            loadCourceList(){
                let search = { licenceId: this.userInfo.licenceId } // ,schoolId: this.userInfo.schoolId
                let param = { controllerName: 'sclCource', methodName: '/list', pageNo: 0, pageSize: 50, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        this.courceList = data.result;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            // 学年学期列表
            loadAcadyearTermList(){
                this.acadyearTermList = [];
                let now = new Date();
                let year = parseInt(now.getFullYear());
                for(let i=(year-3); i<(year+2); i++){
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第一学期');
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第二学期');
                }
                
            },
            // 包含假期的学期判断函数
            // getSemesterWithHolidays(date = new Date()) {
            //     let month = date.getMonth() + 1; // 1-12月
            //     let year = parseInt(date.getFullYear());

            //     // 第一学期：9月-次年2月(包含寒假)
            //     if (month >= 9 || month <= 2) {
            //         this.nowSemester =  year + '-' + (year+1) +  '第一学期';
            //     } 

            //     // 第二学期：3月-8月(包含暑假)  学年：上一年-当年
            //     else if (month >= 3 && month <= 8) {
            //         this.nowSemester = (year - 1) + '-' + year + ' 第二学期';
            //     }

            //     console.log("当前学期=======》", this.nowSemester);
            // },
            // 必选校验
            handleSubmit() {
              
                this.showValidation = true;
                let isNull = this.hasEmptyValues()
                // console.log("isNull",isNull);
                if(isNull) {
                    this.$message.warning("数据存在空值，请检查")
                    return
                }
                // console.log("wwwwwwww");
                this.submitCheck = true
                let param = { controllerName: 'akExam', methodName: '/insertBatch', param: {data: this.examList}};
                return simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
            
                    console.log('newExam', code);
                    if (code == 0) {
                        this.$message.success("创建考试成功！")
                        this.dialogVisible = false;
                        this.submitCheck = false
                        // that.$emit('ok');
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.$message.error("创建考试失败！")
                    this.loading = false;
                    this.submitCheck = false
                });

            },
            // 判断空值
            hasEmptyValues() {
                const excludeFields = ['schoolId']; // 要排除的字段
                return this.examList.some(item => {
                    return Object.keys(item)
                        .filter(key => !excludeFields.includes(key)) // 排除指定字段
                        .some(key => 
                            item[key] === '' || item[key] === null || item[key] === undefined
                        );
                });
            },

            // 点击后批量修改考试类型
            handleChange(){
                let category = this.categoryBatch
                this.examList.forEach((element,index) =>{
                    // element.category  = category
                    this.$set(this.examList[index], 'category', category);
                })
            },
            // 关闭弹窗
            cancel(){
                this.showValidation = false
                this.examList = []
                this.categoryBatch = null
                this.dialogVisible = false
            },
            // 考试名称特殊字符过滤(直接转义)
            checkName(rule, value, callback){
                let specialKey = "@[`~!#$^&*()=|{}':;',\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'\t\n\r+%";
                for (let i = 0; i < value.length; i++) {
                    if (specialKey.indexOf(value.substr(i, 1)) > -1) {
                        callback(new Error('标题不能包含/\\*:?"<>| 等特殊字符'));
                        return
                    }
                }
                callback();
            },
            isEmpty(value) {
                return value === '' || value === null || value === undefined;
            },






        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .search_container{

    }
    .btnRight{
        float: right;
        margin-right: 0px !important;
    }
    .searchArea{
        background:rgba(255,255,255,1);
        border-radius:2px;
        padding: 18px 18px 0;
    }
    .table_container{
        padding: 10px;
        background: #fff;
        border-radius: 2px;
    }
    .el-dialog--small{
       width: 600px !important;
    }
    .pagination{
        text-align: left;
        margin-top: 10px;
    }

    .error-border {
        .el-input__inner {
            border-color: #f56c6c;
        }
    }

    .error-text {
        color: #f56c6c;
        font-size: 12px;
        margin-top: 5px;
    }

</style>


